/**
 * LYT Team Redux Reducer
 * Manages LYT internal team members state
 */

import {
    LYT_TEAM_MEMBERS_REQUEST,
    LYT_TEAM_MEMBERS_SUCCESS,
    LYT_TEAM_MEMBERS_ERROR,
    LYT_TEAM_MEMBERS_RESET,
    LYT_TEAM_MEMBERS_SET_PARAMS,
} from './lyt-team.actions';

const initialMembersParams = {
    searchTerm: '',
    page: 1,
    limit: 10,
    sortBy: null,
    sortOrder: null,
    roleFilter: null,
};

const initialState = {
    members: {
        data: [],
        loading: false,
        error: null,
        pagination: {
            offset: 0,
            limit: 10,
            count: 0,
        },
        params: { ...initialMembersParams },
    },
};

/**
 * LYT Team reducer
 * @param {Object} state - Current state
 * @param {Object} action - Action object
 * @returns {Object} New state
 */
const lytTeamReducer = (state = initialState, action) => {
    switch (action.type) {
        case LYT_TEAM_MEMBERS_SET_PARAMS:
            return {
                ...state,
                members: {
                    ...state.members,
                    params: {
                        ...state.members.params,
                        ...action.payload,
                    },
                },
            };

        case LYT_TEAM_MEMBERS_REQUEST:
            return {
                ...state,
                members: {
                    ...state.members,
                    loading: true,
                    error: null,
                },
            };

        case LYT_TEAM_MEMBERS_SUCCESS: {
            const { data, pagination } = action.payload;
            return {
                ...state,
                members: {
                    ...state.members,
                    data,
                    loading: false,
                    error: null,
                    pagination: {
                        offset: pagination?.offset ?? 0,
                        limit: pagination?.limit ?? state.members.pagination.limit,
                        count: pagination?.count ?? 0,
                    },
                },
            };
        }

        case LYT_TEAM_MEMBERS_ERROR:
            return {
                ...state,
                members: {
                    ...state.members,
                    loading: false,
                    error: action.payload,
                },
            };

        case LYT_TEAM_MEMBERS_RESET:
            return {
                ...state,
                members: {
                    ...initialState.members,
                    params: { ...initialMembersParams },
                },
            };

        default:
            return state;
    }
};

export default lytTeamReducer;
